import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { PageHeader, PageLoader, EmptyState } from '@/components/common/Layout';
import { Card } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Input } from '@/components/ui/input';
import { api } from '@/lib/api';
import { fmtDate, fmtPct } from '@/lib/format';
import { Satellite } from 'lucide-react';

export default function ObservationsPage() {
  const [items, setItems] = useState(null);
  const [q, setQ] = useState('');

  useEffect(() => { api.get('/observations', { params: { limit: 200 } }).then(r => setItems(r.data)); }, []);

  const filtered = (items || []).filter(o => !q || (o.data_source + o.sensor + o.notes).toLowerCase().includes(q.toLowerCase()));

  return (
    <div className="p-6 max-w-[1400px] mx-auto">
      <PageHeader title="Observations" subtitle="Ingested satellite scenes ready for analysis." />
      <Card className="p-3 mb-4 flex gap-2">
        <Input placeholder="Search source, sensor, notes…" value={q} onChange={e => setQ(e.target.value)} className="max-w-sm" data-testid="obs-search" />
      </Card>
      {!items ? <PageLoader /> : filtered.length === 0 ? <EmptyState title="No observations" /> : (
        <Card className="p-0 divide-y divide-border">
          {filtered.map(o => (
            <Link key={o.id} to={`/app/observations/${o.id}`} className="flex items-center gap-3 p-3 hover:bg-secondary/60" data-testid={`obs-row-${o.id}`}>
              <Satellite size={16} className="text-primary" />
              <div className="flex-1 min-w-0">
                <div className="text-sm font-medium">{o.data_source} · {o.sensor}</div>
                <div className="text-xs text-muted-foreground font-mono">{fmtDate(o.acquired_at)}</div>
              </div>
              <Badge variant="outline" className="text-[10px]">Cloud {fmtPct(o.cloud_coverage_pct, 0)}</Badge>
              <Badge variant="outline" className="text-[10px]">{o.spatial_resolution_m}m</Badge>
              <Badge variant="outline" className="text-[10px]">{o.quality}</Badge>
              <Badge variant="secondary" className="text-[10px]">{o.processing_status}</Badge>
            </Link>
          ))}
        </Card>
      )}
    </div>
  );
}
